<template>
  <div>
    <div v-for="result in results" :key="`${result.questionnaire} - CHARTS`" class="text-center">
      <h2 class="text-2xl mx-auto mb-8">
        Questionário - {{ result.questionnaire }} <br />
        <small>({{ result.state }} - {{ result.city }})</small>
      </h2>
      <br />
      <div class="text-justify">
        <textarea-input
          label="Introdução"
          readonly
          v-model="intro_report"
          @callbackClick="showModalIntro"
        />
        <modal
          v-show="modal_intro"
          v-model="intro_report"
          context="current"
          @close="closeModalIntro"
        />
      </div>
      <br />
      <p class="text-justify my-5 font-bold text-xl">Lista de perguntas e Insights</p>
      <br />
      <br />
      <div v-for="(chart, index) in result.charts" :key="index" class="mb-10">
        <div
          class="flex flex-wrap"
          :class="{
            '-mb-6': chart.chart !== 'LIST',
            '-mb-10': chart.chart === 'LIST',
          }"
        >
          <v-md-preview :text="chart.question" class="text-md font-sans text-justify" />
        </div>

        <div @click="setAnalysis(chart._question)">
          <highcharts v-if="chart.chart !== 'LIST'" :options="chart.chart" class="mx-auto" />
          <div v-else class="overflow-y-auto overflow-x-hidden mx-auto">
            <table class="w-full mx-3 whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">Resposta</th>
                <th class="px-6 pt-6 pb-4">Data</th>
              </tr>

              <tr
                v-for="(item, index) in chart.list"
                :key="index"
                class="text-left hover:bg-gray-100 focus-within:bg-gray-100"
              >
                <td
                  class="border-t px-2 pt-2 pb-1"
                  :class="{ italic: item.text === 'Não respondeu' }"
                >
                  {{ item.text }}
                </td>
                <td class="border-t px-2 pt-2 pb-1">
                  {{ item.date }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="mt-4" v-if="getAnalysis(chart._question).length > 0">
          <Accordion>
            <AccordionTab
              v-for="(analysedQuestion, index) in getAnalysis(chart._question)"
              :key="index"
            >
              <template #header>
                <p
                  class="font-bold text-justify accordion-title"
                  @click="generateInsightPreview(analysedQuestion)"
                >
                  {{ analysedQuestion.split(';')[0] }}
                </p>
              </template>
              <div>
                <loading-button
                  :loading="generatingInsight"
                  class="btn-indigo"
                  type="button"
                  v-if="
                    currentInsight_beingGenerated == `insight-${analysedQuestion.split(';')[2]}` &&
                    generatingInsight
                  "
                >
                </loading-button>

                <p :id="`insight-${analysedQuestion.split(';')[2]}`" class="text-justify"></p>
              </div>
            </AccordionTab>
          </Accordion>
        </div>
      </div>
      <br />
      <div class="text-justify">
        <textarea-input
          label="Conclusão"
          readonly
          v-model="footer_report"
          @callbackClick="showModalFooter"
        />
        <modal
          v-show="modal_footer"
          v-model="footer_report"
          context="current"
          @close="closeModalFooter"
        />
      </div>
      <br />
      <div>
        <loading-button
          :loading="generating_pdf"
          class="btn-indigo"
          type="button"
          @click="gerarPDF"
        >
          Gerar pdf
        </loading-button>
      </div>
    </div>
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :manual-pagination="true"
      :filename="'teste'"
      :pdf-quality="2"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      :htmlToPdfOptions="{
        margin: [20, 20, 20, 20],
        beforeRender: handleBeforeRender,
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      }"
    >
      <section slot="pdf-content">
        <section
          style="
            display: flex;
            max-width: 630px;
            min-height: 930px;
            height: 950px;
            max-height: 950px;
            background: url('/capateste.jpeg') no-repeat;
            background-size: cover;
          "
        ></section>
        <div class="html2pdf__page-break" />
        <div style="width: 630px">
          <p style="font-weight: 600; margin-bottom: 20px; font-size: 18px; white-space: pre-line">
            Introdução
          </p>
          <p
            style="text-align: justify; margin-bottom: 15px; line-height: 30px"
            v-html="intro_report"
          ></p>
        </div>
        <div class="html2pdf__page-break" />
        <section>
          <div v-for="(result, index) in results" :key="index">
            <div v-for="(chart, index) in result.charts" :key="index">
              <div style="width: 630px">
                <v-md-preview
                  :text="chart.question"
                  class="text-md font-sans"
                  style="width: 630px"
                />
                <div style="width: 630px">
                  <highcharts v-if="chart.chart !== 'LIST'" :options="chart.chart" />
                </div>
                <ul>
                  <li
                    v-for="(analysedQuestion, index) in getAnalysis(chart._question)"
                    :key="index"
                    class="text-justify my-3"
                  >
                    <p style="font-weight: 600; margin-bottom: 5px; font-size: 18px">
                      {{ analysedQuestion.split(';')[0] }}
                    </p>
                    <p
                      v-for="(paragraph, index) in getParagraphs(
                        localInsights[analysedQuestion.split(';')[2]],
                      )"
                      :key="index"
                      style="
                        line-height: 25px;
                        text-align: justify;
                        line-height: 25px;
                        break-inside: avoid;
                        word-wrap: break-word;
                        text-wrap: wrap;
                        margin: 15px 0;
                      "
                    >
                      {{ paragraph }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <br />
          </div>
        </section>
        <div class="html2pdf__page-break"></div>
        <div style="width: 630px; break-inside: avoid">
          <p style="font-weight: 600; margin-bottom: 20px; font-size: 18px">Conclusão</p>
          <!-- <p
            style="
              text-align: justify;
              margin-bottom: 15px;
              line-height: 30px;
              white-space: pre-line;
              word-wrap: break-word;
              break-inside: avoid;
            "
            v-html="footer_report"
          ></p> -->
          <p
            style="
              text-align: justify;
              margin-bottom: 15px;
              line-height: 30px;
              white-space: pre-line;
              word-wrap: break-word;
              break-inside: avoid;
            "
            v-for="(paragraph, index) in splitTextFooter(footer_report)"
            :key="index"
          >
            {{ paragraph }}
          </p>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import axios from 'axios'
import { Chart as highcharts } from 'highcharts-vue'
import HighCharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import Icon from '@/Shared/Icon'
import TextareaInput from '@/Shared/TextareaInput'
import VueHtml2pdf from 'vue-html2pdf'
import Modal from '../Pages/Questionnaires/Modal.vue'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import LoadingButton from '@/Shared/LoadingButton'

HighchartsMore(HighCharts)

export default {
  components: {
    highcharts,
    Icon,
    TextareaInput,
    VueHtml2pdf,
    Modal,
    Accordion,
    LoadingButton,

    AccordionTab,
  },
  props: {
    index: Number,
    indicators: Array,
    results: Array,
    analysis: Array,
    configForm: Object,
    report_full: Array,
  },
  data() {
    return {
      analysed: null,
      intro_report: '',
      footer_report: '',

      modal_intro: false,
      modal_footer: false,
      currentInsight_beingGenerated: '',
      generatingInsight: false,
      localInsights: [],
      generating_pdf: false,
    }
  },
  updated() {
    setTimeout(() => {
      for (const preview of document.getElementsByClassName('v-md-editor-preview')) {
        for (const child of preview.getElementsByTagName('*')) {
          child.classList.add('font-sans', 'text-md')
        }
      }
    }, 2.5e2)

    if (this.report_full) {
      this.intro_report = this.report_full[0]
      this.footer_report = this.report_full[1]
    }
  },
  methods: {
    getParagraphs(bigString) {
      if (bigString == null || bigString == undefined) {
        return []
      } else {
        let arr = bigString.split('\n').filter((paragraph) => paragraph.trim() !== '')
        console.log(arr)
        return arr
      }
    },
    getRandomColor() {
      // Gera uma cor hexadecimal aleatória
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    splitTextFooter(footer) {
      let dividedText = footer.split('\n')
      // console.log(dividedText)
      // console.log(footer.split('\n').filter((paragraph) => paragraph.trim() !== ''))
      return footer.split('\n').filter((paragraph) => paragraph.trim() !== '')
    },
    showModalIntro() {
      this.modal_intro = true
    },
    showModalFooter() {
      this.modal_footer = true
    },
    closeModalIntro() {
      this.modal_intro = false
    },
    closeModalFooter() {
      this.modal_footer = false
    },
    async gerarPDF() {
      this.generating_pdf = true
      for (const result of this.results) {
        for (const chart of result.charts) {
          let insights = this.getAnalysis(chart._question)

          for (const analysedQuestion of insights) {
            console.log(analysedQuestion)

            let rule_id = analysedQuestion.split(';')[2]

            if (!this.localInsights[rule_id]) {
              console.log('não foi gerado - ' + analysedQuestion.split(';')[2])
              await this.generateInsightPreview(analysedQuestion)
            } else {
              console.log('já foi gerado - ' + analysedQuestion.split(';')[2])
            }
          }
        }
      }
      this.$refs.html2Pdf.generatePdf()
      this.generating_pdf = false
    },
    handleBeforeRender(pdf) {
      // Obtém todas as páginas do PDF
      const pages = pdf.internal.pages

      // Itera sobre cada página
      for (let i = 1; i <= pages.length; i++) {
        // Verifica se a página atual é a primeira
        if (i === 1) {
          // Define margens diferentes para a primeira página
          pages[i].getPage().margins = { top: 10, right: 10, bottom: 10, left: 10 }
        } else {
          // Define margens padrão para as páginas subsequentes
          pages[i].getPage().margins = { top: 20, right: 20, bottom: 20, left: 20 }
        }
      }
    },
    setAnalysis(question) {
      if (this.analysed === question) {
        this.analysed = null

        return
      }

      this.analysed = question
    },
    isAnalysed(id) {
      for (const questions of this.analysis) {
        for (const question in questions) {
          if (Number(question) === Number(id)) {
            return true
          }
        }
      }

      return false
    },
    getAnalysis(id) {
      const analysed = []

      for (const questions of this.analysis) {
        for (const question in questions) {
          if (Number(question) === Number(id)) {
            questions[question].forEach((q) => {
              if (!analysed.includes(q)) {
                return analysed.push(q)
              }
            })
          }
        }
      }

      return analysed
    },
    async generateInsightPreview(rule_set) {
      let rule_title = rule_set.split(';')[0]
      let question_text = rule_set.split(';')[1]
      let rule_id = rule_set.split(';')[2]

      // console.log(rule_title)
      // console.log(question_text)
      // console.log(rule_id)

      let pName = `insight-${rule_id}`

      this.currentInsight_beingGenerated = pName

      if (document.getElementById(pName).innerText.trim() !== '') {
        this.currentInsight_beingGenerated = ''
        return
      } else {
        this.generatingInsight = true
        const response = await axios.post(this.route('insight.generate'), {
          question_text,
          _token: this.$page.props.auth.user.csrf_token,
        })

        this.generatingInsight = false
        document.getElementById(pName).innerText = response.data.answer
        this.currentInsight_beingGenerated = ''

        this.localInsights[rule_id] = response.data.answer
      }
    },
  },
}
</script>

<style scoped>
.accordion-title:hover {
  color: #00a39a;
}

.pdf-text {
  line-height: 25px;
  text-align: justify;
  word-wrap: break-word;
  break-inside: avoid;
  text-wrap: wrap;
}
</style>
